/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

function formatMaskedCreditCard(number) {
    var defaultFormat = {
        beginning: '',
        stars: '',
        ending: '',
    };
    if (!(number && number.length)) {
        return defaultFormat;
    }
    if (number.length < 6) {
        return {
            beginning: number.replace(/ /g, '\u00a0'),
            stars: '',
            ending: '',
        };
    }

    return {
        beginning: number.substring(0, 2),
        stars: '**\u00a0****\u00a0****\u00a0',
        ending: number.substring(number.length - 4),
    };
}

function formatMaskedIban(number) {
    var defaultFormat = {
        beginning: '',
        stars: '',
        ending: '',
    };
    if (!(number && number.length)) {
        return defaultFormat;
    }
    if (number.length < 10) {
        return {
            beginning: number.replace(/ /g, '\u00a0'),
            stars: '',
            ending: '',
        };
    }

    return {
        beginning: number.substring(0, 4) + '\u00a0' + number.substring(4, 8) + '\u00a0',
        stars: '****\u00a0**',
        ending: number.substring(number.length - 2),
    };
}

function isCreditCard(account) {
    return account.maskedAccount && account.maskedAccount.displayLabel && account.maskedAccount.displayLabel.indexOf('|') > -1;
}

function hasStars(account) {
    return account.maskedAccount && account.maskedAccount.displayLabel && account.maskedAccount.displayLabel.indexOf('*') > -1;
}

function formatMaskedAccount(account) {
    if (isCreditCard(account)) {
        return formatMaskedCreditCard(account.maskedAccount.number);
    }
    if (hasStars(account)) {
        return formatMaskedIban(account.maskedAccount.displayLabel);
    }
    return {
        beginning: account.maskedAccount.displayLabel.replace(/ /g, '\u00a0'),
        stars: '',
        ending: '',
    };
}

function formatDateString(account) {
    var month = account.maskedAccount.expiryMonth < 10 ? '0' + account.maskedAccount.expiryMonth : account.maskedAccount.expiryMonth;

    return month + '\u00a0/\u00a0' + account.maskedAccount.expiryYear;
}

function isExpired(account) {
    const today = new Date();
    return compareDates(today, account);
}

function compareDates(today, account) {
    if (account && account.maskedAccount && account.maskedAccount.expiryMonth && account.maskedAccount.expiryYear) {
        return (
            today.getFullYear() > account.maskedAccount.expiryYear ||
            (today.getFullYear() === account.maskedAccount.expiryYear && today.getMonth() + 1 > account.maskedAccount.expiryMonth)
        );
    }
    return false;
}

module.exports = {
    formatDateString: formatDateString,
    formatMaskedAccount: formatMaskedAccount,
    formatMaskedIban: formatMaskedIban,
    formatMaskedCreditCard: formatMaskedCreditCard,
    isExpired: isExpired,
};
